import { Injectable } from "@angular/core";
import { Observable } from "rxjs/Observable";
import { BehaviorSubject } from "rxjs/BehaviorSubject";
import { map } from "rxjs/operators";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { StorageService } from "app/main/module/common/service/storage.service";
import { environment } from "environments/environment";
import { Globals } from "../../common/global";

@Injectable()
export class TicketsService {
    public pageSubject: BehaviorSubject<number>;
    public pageObservable: Observable<number>;

    baseUrl = environment.baseUrl;

    apiUrl = this.baseUrl + "/api/v1/";
    latestEntry: any;
    startingEntry: any;
    ROWS = 10;

    orderBy = "dateTimeNum";
    currentPage = 0;

    constructor(
        public globals: Globals,
        private userService: StorageService,
        public httpClient: HttpClient
    ) {}

    getTickets(
        page: number,
        perPage: number,
        searchText?: string,
        startDate?: string,
        endDate?: string,
        selectedStatus?: string
    ): Observable<any> {
        const lab_id = this.userService.getCookie("lab_id");
        const token = this.userService.getCookie("token");
        const role = this.userService.getCookie("role");
        const assignTo = this.userService.getCookie('userId');

        const httpOptions = {
            headers: new HttpHeaders({
                Authorization: token, 
                "Content-Type": "application/json",
            }),
            params: new HttpParams()
                .set("lab_id", lab_id)
                .set("page", page.toString())
                .set("per_page", perPage.toString()),
        };

        if (searchText) {
            httpOptions.params = httpOptions.params.set("search", searchText);
        }
        if (startDate) {
            httpOptions.params = httpOptions.params.set(
                "startDate",
                startDate
            );
        }
        if (endDate) {
            httpOptions.params = httpOptions.params.set("endDate", endDate);
        }

        if(role === 'technician'){
            httpOptions.params = httpOptions.params.set("assign_to", assignTo);
        }

        if (selectedStatus && selectedStatus != 'all') {
            httpOptions.params = httpOptions.params.set(
                "status",
                selectedStatus
            );
        }

        return this.httpClient.get(`${this.apiUrl}tickets`, httpOptions);
    }

    getSingleTicket(id): Observable<any> {
        const lab_id = this.userService.getCookie("lab_id");
        const token = this.userService.getCookie("token");
        const httpOptions = {
            headers: new HttpHeaders({
                Authorization: token,
                "Content-Type": "application/json",
                "Access-Control-Allow-Origin": "*",
                "Access-Control-Allow-Credentials": "true",
            }),
        };
        const url = `${this.apiUrl}tickets?lab_id=${lab_id}&id=${id}`;
        return this.httpClient.get(url, httpOptions);
    }

    postTickets(ticketData): Observable<any> {
        const lab_id = this.userService.getCookie("lab_id");
        const token = this.userService.getCookie("token");
        const center = this.userService.getCookie("center");
        const httpOptions = {
            headers: new HttpHeaders({
                Authorization: token,
                // "Content-Type": "multipart/form-data",
                "Access-Control-Allow-Origin": "*",
                "Access-Control-Allow-Credentials": "true",
            }),
        };
        const url = `${this.apiUrl}tickets?lab_id=${lab_id}`;
        return this.httpClient.post(url, ticketData, httpOptions);
    }

    updateTicket(ticketData, id): Observable<any> {
        const lab_id = this.userService.getCookie("lab_id");
        const token = this.userService.getCookie("token");
        const center = this.userService.getCookie("center");
        const httpOptions = {
            headers: new HttpHeaders({
                Authorization: token,
                // "Content-Type": "application/json",
                "Access-Control-Allow-Origin": "*",
                "Access-Control-Allow-Credentials": "true",
            }),
        };
        const url = `${this.apiUrl}tickets?lab_id=${lab_id}&id=${id}`;
        return this.httpClient.put(url, ticketData, httpOptions);
    }

    getUsers(role): Observable<any> {
        const lab_id = this.userService.getCookie("lab_id");
        const token = this.userService.getCookie("token");
        const httpOptions = {
            headers: new HttpHeaders({
                Authorization: token,
                "Content-Type": "application/json",
                "Access-Control-Allow-Origin": "*",
                "Access-Control-Allow-Credentials": "true",
            }),


        };
        const url = `${this.apiUrl}tickets/users?lab_id=${lab_id}&role=${role}`;
        return this.httpClient.get(url, httpOptions);
    }
}
